import { useEffect, useState } from "react";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { protectedResources } from "../../authConfig";
import "./ReportFilterComponent.scss";

type ReportFilterComponentProps = {
  onFilterChange: (filters: Record<string, string>) => void;
};

// Keys must match LOOKUP_DEFINITIONS in server/repository/ReportingDataRepo.ts
const FILTER_DEFS: { key: string; label: string }[] = [
  { key: "region", label: "Region" },
  { key: "businessLine", label: "Business Line" },
  { key: "serviceLine", label: "Service Line" },
  { key: "officeName", label: "Office" },
];

const DEFAULT_FILTERS: Record<string, string> = { directOnly: "true" };

const ReportFilterComponent: React.FC<ReportFilterComponentProps> = ({ onFilterChange }) => {
  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.read,
  });

  const [options, setOptions] = useState<Record<string, string[]>>({});
  const [filters, setFilters] = useState<Record<string, string>>(DEFAULT_FILTERS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all(
      FILTER_DEFS.map(def =>
        execute("GET", `/api/reports/lookup/${def.key}`)
          .then(values => [def.key, Array.isArray(values) ? values : []] as const)
      )
    ).then(results => {
      setOptions(Object.fromEntries(results));
    }).finally(() => {
      setLoading(false);
    });
    onFilterChange(DEFAULT_FILTERS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (key: string, value: string) => {
    const next = { ...filters, [key]: value };
    setFilters(next);
    onFilterChange(next);
  };

  if (loading) {
    return <p>Loading filters...</p>;
  }

  return (
    <div className="report-filter">
    
      {FILTER_DEFS.map(def => (
        <div key={def.key} className="report-filter-item">
          <label htmlFor={`filter-${def.key}`} className="fnt-wght-bold">{def.label}</label>
          <select
            id={`filter-${def.key}`}
            value={filters[def.key] ?? ""}
            onChange={e => handleChange(def.key, e.target.value)}
          >
            <option value="">All</option>
            {(options[def.key] ?? []).map(value => (
              <option key={value} value={value}>{value}</option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
};

export default ReportFilterComponent;
